import React, { Component } from 'react';
import styles from './styles.scss';
import CONFIG from '../../config';
import http from '../../helpers/http';
import WJSON from '../../helpers/json';
import qs from "query-string";
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import WModal from '../../components/WModal/WModal';
import UserInfo from '../../helpers/userinfo';
import WFirebase from '../../helpers/firebase';

class Drawing extends Component 
{
  constructor(props){
    super(props);
    
    let drawing_ids = []
    
    let query = qs.parse(props.location.search)
    
    if (query.drawing_ids)
    {
      drawing_ids = WJSON.decode(query.drawing_ids)
    }

    this.state = {
      drawing_ids:drawing_ids
    };
  }
  componentDidMount(){
    console.log('params', this.props.match.params.drawing_ids)
    
    this.pullUserInfo()
  }
  pullUserInfo()
  {
    this.setState({ show_spinner: true });

    UserInfo.pullData((code=100, userinfo={}, reason='發生錯誤，請洽社區物管') => {
      this.setState({ show_spinner: false });
      
      if (userinfo.mail && userinfo.mail.length > 0)
      {
        this.refs.sync_email.checked = true
        this.refs.email.value = userinfo.mail
      }

    })
  }
  getFile(type = 'email'){

    const {drawing_ids=[]} = this.state

    console.log(drawing_ids)

    if (drawing_ids.length == 0)
    {
      return WModal.show('請選擇要下載的圖檔');
    }

    let email = this.refs.email.value
    let cc_mail = this.refs.cc_mail.value
    let sync_email = this.refs.sync_email.checked

    if (email.length == '')
    {
      return WModal.show('請輸入Email');
    }

    this.setState({ show_spinner: true });

    http.post(CONFIG.API_HOST + 'api/v1.3/drawing/download', 
      {
        action      : "email",
        drawing_ids : this.state.drawing_ids,
        email       : email,
        cc_mail     : cc_mail,
        sync_email  : sync_email
      }
      , 
      (state, res) => {

        this.setState({ show_spinner: false });

        const {code=100, reason='發生錯誤', data={} } = res;

        if (state === false) { return  WModal.show('發生錯誤'); }

        if (code !== 200)    { return WModal.show(reason); }

        const { download_url = null } = data;

        WModal.show('已寄至您的信箱', "", {callback:(title) => {
          console.log('this.props.history', this.props.history)
          this.props.history.goBack()
        }})
        
    })
  }
  render()
  {
    console.log('window.location.href', window.location.href);
    return (
      <div className={styles.page_container}>
        <div className={'container'}>
          <h1>圖面下載</h1>
          <form onSubmit={(e) => {e.preventDefault();}} >
            <div>
              <div className="form-group">
                <label>住戶Email</label>
                <input className="form-control" type='email'
                       name="email"
                       ref="email"
                       onKeyPress={(e)=>{e.target.keyCode === 13 && e.preventDefault();}}
                />
                <div className={[styles.checkbox, "checkbox"].join(' ')}>
                  <label>
                    <input type="checkbox" 
                           name="sync_email"
                           ref="sync_email"
                            />
                    <span className={styles.checkmark}/>
                    同步更新住戶資料
                  </label>
                </div>
              </div>
              <div className="form-group">
                <label>設計師Email</label>
                <input className="form-control" type='email'
                       name="cc_mail"
                       ref="cc_mail"
                       onKeyPress={(e)=>{e.target.keyCode === 13 && e.preventDefault();}}
                />
              </div>
              <hr/>
              <div className="form-group">
                <label>貼心提醒</label>
                <ul>
                  <li>郵件主旨：建案名-設計圖面-戶號-遠雄社區雲</li>
                  <li>未收到信件：請至垃圾信件匣查看，並將信件設定為「非垃圾信」，未來即可正常收件</li>
                </ul>
              </div>
            </div>
            <div className={styles.anchor}>
              <div className="container_btn">
                <button type="button" className="btn btn-primary" onClick={() => {

                  WFirebase.logEvent('ID_Download_PS',{'SendEmail': UserInfo.houseid})

                  this.getFile()
                }} >
                  送出
                </button>
                <button type="button" className="btn btn-default" 
                onClick={() => {

                  WFirebase.logEvent('ID_Download_PS',{'UnSendEmail': UserInfo.houseid})

                  this.props.history.goBack()
                }} >
                  取消
                </button>
              </div>
            </div>
          </form>
        </div>
        { this.state.show_spinner && <WMask><WSpinner/></WMask> }
      </div>
    );
  }
}

export default Drawing;


// WEBPACK FOOTER //
// ./src/views/Drawing/Sent.js